const actionsMap = {
    'created': 'Created',
    'updated': 'Updated',
    'deleted': 'Deleted',
    'left': 'Left'
}

export {
    actionsMap
}